import { isValid, parseISO } from "date-fns";
import { IAppealPeriodShema } from "~/entity/Appeals/model/schema";

export const isDateInPeriod = (
  date: Date,
  periodsData: IAppealPeriodShema[]
): boolean => {
  if (!periodsData || periodsData.length === 0) {
    return false;
  }

  return periodsData.some((period) => {
    if (!period.startDate || !period.endDate) {
      return false;
    }

    const startDate = parseISO(period.startDate);
    const endDate = parseISO(period.endDate);

    if (!isValid(startDate) || !isValid(endDate)) {
      return false;
    }

    // Устанавливаем время на начало дня для корректного сравнения
    const today = new Date(date);
    today.setHours(0, 0, 0, 0);
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);

    return today >= start && today <= end;
  });
};
